import { React, useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Space, message, Form, Tag } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, } from 'react-router-dom'
import { default as ProTableOT } from "../../../../utility/ProTable_ot";


const StudentCheckInOverView = () => {
    const navigate = useNavigate();
    const actionRef = useRef()
    const [check, setCheck] = useState();
    const [extra_columns, set_extra_columns] = useState([]);
    const [loading, set_loading] = useState(0);
    const [open, setOpen] = useState(false);
    const [datas, setDatas] = useState([])
    const [default_column, set_default_column] = useState([{
        title: '編號',
        key: 'name_serial',
        dataIndex: 'name_serial',
        align: 'center',
        sorter: false,
    },
    {
        title: '班級',
        key: 'name',
        dataIndex: 'name',
        sorter: false,
        align: 'center',
    },
    {
        title: '課程',
        key: 'lesson_class_data',
        dataIndex: 'lesson_class_data',
        align: 'center',
        sorter: false,
    },
    {
        title: '當期繳費期數',
        key: 'teacher_data',
        dataIndex: 'teacher_data',
        align: 'center',
        sorter: false,
    },
    {
        title: '授課時間',
        key: 'week_time_data',
        dataIndex: 'week_time_data',
        align: 'center',
        sorter: false,
        render: (text, record, index) => {
            return <Space direction="vertical">
                {text.map((value) => {
                    return <Tag color="geekblue">
                        星期{value.week_name} {value?.time_start}-{value?.time_end}
                    </Tag>
                })}
            </Space>
        }
    },
    {
        title: '人數',
        key: 'grade_class_data_not',
        dataIndex: 'grade_class_data',
        align: 'center',
        sorter: false,
        disabled: true,
        render: (text, record, index) => {
            let grade_class_data_first = text?.find(ele => true)
            let bill_payment_grade_class_data = grade_class_data_first?.bill_payment_grade_class_data
            return <>
                {10}/{20}
            </>
        }
    },
    {
        title: '學生名單',
        key: 'grade_class_data',
        dataIndex: 'grade_class_data',
        align: 'center',
        sorter: false,
        disabled: true,
        render: (text, record, index) => {
            return <>
                <Button
                    type="primary"
                    onClick={() => {
                        navigate(`/cramSchool/admin/StudentCheckINDetail/:Id`)
                    }}
                >
                    詳細
                </Button>
            </>
        }
    }
    ]);
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [axiosMode, setAxiosMode] = useState("get")
    const reload = () => {
        actionRef.current.reloadAndRest();
    }
    const addDatas = () => {
        setOpen(true)
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                reload()
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                reload()
                // setSelectedRowsInfo([])
            }
            else if (axiosMode === "get") {
                setDatas(values.data);
                set_loading(false)
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                reload()
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    useEffect(() => {
        setDatas([
            {
                name_serial: "1",
                name: "企鵝班",
                lesson_class_data: "課程1",
                teacher_data: "1期",
                week_time_data: [{ week_name: "日", time_start: "9:00", time_end: "11:30" }, { week_name: "一", time_start: "13:00", time_end: "15:30" }],
                grade_class_data_not: "10/20",
                grade_class_data: ["2023/11/23"],
                option: "2024/4/1"
            },
            {
                name_serial: "2",
                name: "海豚班",
                lesson_class_data: "課程3",
                teacher_data: "1期",
                week_time_data: [{ week_name: "三", time_start: "18:00", time_end: "20:30" }],
                grade_class_data_not: "10/20",
                grade_class_data: ["2023/11/23", "2024/3/2"],
                option: "2024/3/2"
            }
        ]);
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <ProTableOT
                            actionRef={actionRef}
                            columns={default_column}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'news_id'}
                            selections={{
                                // onChange: (index_, data_) => set_data(data_)
                            }}
                            toolBarRender={() =>[]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            dataSource={datas}
                            // request={async (params = {}, sort, filter) => {
                            //     setAxiosMode("get")
                            //     let newParams = {
                            //     };
                            //     let order = setOrders(sort)
                            //     newParams = {
                            //         ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            //         ...newParams,
                            //         order,
                            //         size: params.pageSize,
                            //         cur_page: params.current,
                            //         custom_filter_value: params.keyword ?? "",
                            //         custom_filter_key: custom_filter_key
                            //     };
                            //     newParams = setParamsFilter({
                            //         ...newParams,
                            //     });
                            //     setPageSize(params?.pageSize ?? 20)
                            //     return getFormulaTypeData(newParams)
                            // }}
                            // pageSize={pageSize}
                            scroll={{
                                x: "max-content"
                            }}
                            rowSelection={false}
                        />
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}
export default StudentCheckInOverView;